module.exports = __webpack_public_path__ + "static/STG20_Desktop_2880_Module4_ImageGrid-5bdc9d54f6639b4c0e5b5c066f65e5ad.jpg";